export default defineNuxtRouteMiddleware(async (to, from) => {
    if (!process.client) return
    const authStore = useAuthStore()
    if (!authStore.isLogin) {
        // 持久化 userInfo 可能未命中（首次访问 / 隐私模式），等 cookie 引导一次
        await authStore.bootstrap()
    }
    if (!authStore.isLogin) {
        const localePath = useLocalePath()
        return navigateTo(localePath('/login'))
    }
})
